import React, { PureComponent } from 'react'
import { compose } from 'recompose'
import _ from 'lodash'
import cx from 'classnames'
import { createI13nNode } from '@vzmi/ec-react-i13n'
import styles from './BestSelling.css'
import {
  DEFAULT_BESTSELLER_TERM,
  EXPORT_TEMPLATE_SETTING
} from '../../../../constants/globalTypes'
import { ExcelExport, ExcelExportHelper } from '@vzmi/component_ec_nodejs_util'
import { formDecorator } from '../../../Common/forms'
import PageLayout from '..'
import { getFormValues } from '../../../Proposal/Common/ProposalForm/Shared/util'
import { getDefaultTimezoneMoment } from '../../../../../lib/renderUtil'
import Bestseller, { CONFIG } from '../../Dashboard/BestsellerRanking'
import { IconExportButton } from '../../../Common/ExportButton'
import withConnectedExport from '../../../../containers/Common/WithConnectedExport'
import { withI13nWrapper } from '../../../Common/I13nWrapper'
import { sendGaPv, sendGaClick } from '../../utils/ga'

const customRangeName = '自訂區間'
const ExportHelper = new ExcelExportHelper(EXPORT_TEMPLATE_SETTING.seller.bestSelling)

const gaPageType = 'seller_topsellinglist'
const gaLabel = 's_topsell_list_downloadfile'

export class BestSelling extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      data: [],
      term: DEFAULT_BESTSELLER_TERM,
      periodText: '',
      allowExport: false
    }
  }

  componentDidMount () {
    const { page } = this.props
    const user = _.get(page, 'user', {})
    sendGaPv(gaPageType, user)
  }

  sendPageview = () => {}

  postSetCacheData = (data) => {
    this.setState(() => ({
      ...data,
      allowExport: !_.isEmpty(data)
    }))
  }

  exportExcel = async (e) => {
    const { allowExport } = this.state

    if (!allowExport) { return }

    const {
      openExportModal,
      closeExportModal,
      reduxFormState,
      page
    } = this.props
    const user = _.get(page, 'user', {})
    sendGaClick(gaLabel, user)

    const formValues = getFormValues(reduxFormState)
    const { stockStatus, activeStatus } = formValues

    openExportModal()
    const [error, data] = await this.bestseller.getTotalPaginationBestsellers()
    if (error) {
      closeExportModal({ isError: true })
    } else {
      const {
        term,
        sortType,
        changeCustomTab,
        periodSegment: {
          start,
          end
        }
      } = this.bestseller.state

      const getStockAndActiveStatusText = (stockStatus, activeStatus) => {
        if (stockStatus && activeStatus) {
          return '(庫存=0且濾除已停售賣場)'
        }
        if (stockStatus) {
          return '(庫存=0)'
        }
        if (activeStatus) {
          return '(濾除已停售賣場)'
        }
        return ''
      }

      const processedData = _.map(
        data,
        oneRowData => {
          // excel 資料不需要 trend 這一欄
          const omittedObject = _.omit(
            oneRowData,
            ['trend']
          )
          return omittedObject
        })
      const option = {
        fileName: ExportHelper.getFileName({
          sortType: _.capitalize(sortType),
          term: changeCustomTab ? customRangeName : term,
          nowDate: getDefaultTimezoneMoment(),
          stockAndActive: getStockAndActiveStatusText(stockStatus, activeStatus)
        }),
        sheets: [
          {
            name: ExportHelper.getSheetName({
              startDate: getDefaultTimezoneMoment(start),
              endDate: getDefaultTimezoneMoment(end)
            }),
            headers: ExportHelper.getSheetHeaders(),
            data: ExportHelper.convertDataByHeaders(processedData)
          }
        ]
      }
      const ExcelExporter = new ExcelExport(option)
      ExcelExporter.download({ bookType: ExportHelper.getBookType() })

      closeExportModal()
    }
  }

  onGaClick = (label) => {
    const { page } = this.props
    const user = _.get(page, 'user', {})
    sendGaClick(label, user)
  }

  render () {
    const { className, actions } = this.props
    const { sharedLink = '#test#' } = this.props
    const { allowExport } = this.state
    const locationHash = _.get(this.props, 'location.hash')
    const isCustomTab = _.includes(locationHash, encodeURI(customRangeName))
    const clz = cx(styles.BestSelling, className)

    return (
      <PageLayout>
        <div className={clz}>
          <Bestseller
            rowLimit={20}
            withPagination
            onGaClick={this.onGaClick}
            title={(
              <div className={styles.bestSellingTitle}>
                熱門賣場排行
                <IconExportButton
                  disabled={!allowExport}
                  data-role='best-selling-export-button'
                  className={cx(styles.bestSellingExportBtn, { [styles.customBestSellingExportBtn]: isCustomTab })}
                  onClick={this.exportExcel}
                  label='下載整筆檔案'
                />
                <span className={cx(styles.tips, { [styles.customTips]: isCustomTab })}>最多下載前 1000 筆</span>
              </div>
            )}
            key='bestseller'
            ref={r => (this.bestseller = r)}
            disableMoreLink
            disableInnerTermSelect
            sharedLink={sharedLink}
            locationHash={locationHash}
            postSetCacheData={this.postSetCacheData}
            actions={actions}
          />
        </div>
      </PageLayout>
    )
  }
}

const withBestsellerForm = wrappedComponent => formDecorator(CONFIG)(wrappedComponent)

const hoc = compose(
  withConnectedExport,
  createI13nNode,
  withI13nWrapper,
  withBestsellerForm
)

export default hoc(BestSelling)
